import React from "react";
import { Triangle } from "react-loader-spinner";
import "./LoadingSpinner.modules.css";

const LoadingSpinner = () => {
  return (
    <div className="spinner-wrapper bg-light-white dark:bg-dark-blue">
      <div className="spinner">
        <div className="slide-content">
          <div className="flex justify-center">
            <Triangle
              ariaLabel="loading-indicator"
              width={100}
              height={100}
              color="#04BF00"
            />
          </div>
          <div>
            <h4 className="loading-text tracking-[.08em] text-lime text-center text-[#04BF00] my-5">
              Ishtiyak is working
            </h4>
          </div>
          <div className="progress2 progress-moved">
            <div className="progress-bar2"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
